import { css, cx, useTheme } from '@fable/theme'
import { RadarChart } from './RadarChart'
import { ChartLegend } from '../../../chart_legend'
import { FlexBox } from '@fable/components'
import { useGoalHabits } from '../../lib/ctx'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'
import { MonthRadarYAxis } from './MonthRadarYAxis'

export const MonthRadarChart = () => {
  const [isZeroState, type] = useGoalHabits((s) => [s.isZeroState, s.type])
  const theme = useStatsTheme((s) => s.theme)
  const { colors } = useTheme()

  const getLabel = () => {
    switch (type) {
      case 'active_days':
        return 'Days'
      case 'books_finished':
        return 'Books'
      case 'pages_read':
        return 'Pages'
    }
  }

  return (
    <div
      className={css`
        padding: 10px 0 10px;
        width: 100%;
        position: relative;
      `}
    >
      <FlexBox
        className={css`
          width: 100%;
        `}
        centerAll
      >
        <div
          className={cx(
            'anim__month-radar-chart',
            css`
              width: 100%;
              height: 320px;
              position: relative;
              transform: scale(0.8);
              opacity: 0;
              will-change: transform, opacity;

              // Override the default stroke-dasharray for the radar chart
              svg > g:nth-of-type(1) > g:nth-of-type(1) path:nth-of-type(odd) {
                stroke-dasharray: none;
              }
            `,
            isZeroState
              ? css`
                  // Hide the radar chart grid lines for the zero state
                  svg > g:nth-of-type(1) > g:not(:first-of-type) {
                    display: none;
                  }
                `
              : ''
          )}
        >
          <RadarChart />
          <MonthRadarYAxis />
        </div>
      </FlexBox>
      <ChartLegend
        className={css`
          padding-top: 20px;
        `}
        items={[
          {
            color: theme.colors.primary,
            label: `${getLabel()} read per month`,
          },
          {
            color: colors.uiPearl,
            label: 'Your monthly goal',
          },
        ]}
      />
    </div>
  )
}
